<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

// ============================================================================
// v104: TRAVA DE ABA ÚNICA (pedido do Kairo 06/07) — estilo WhatsApp Web.
// As abas do MESMO navegador conversam via BroadcastChannel:
//   - aba nova manda "hello"; se uma aba ativa responder "taken", a nova
//     mostra o bloqueio de tela cheia com o botão "Usar aqui";
//   - "Usar aqui" manda "takeover": esta aba assume e as outras bloqueiam.
// Limite conhecido: só detecta abas do MESMO navegador/perfil — computadores
// diferentes com o mesmo login exigiriam controle de sessão no servidor.
// Navegador sem BroadcastChannel: trava desligada (comportamento antigo).
// ============================================================================

const blocked = ref(false);
const tabId = Math.random().toString(36).slice(2) + Date.now().toString(36);
let channel = null;
let awaitingReply = false;

const send = payload => {
  if (channel) channel.postMessage({ ...payload, from: tabId });
};

onMounted(() => {
  if (typeof BroadcastChannel === 'undefined') return;
  channel = new BroadcastChannel('segue-aba-unica');
  channel.onmessage = ({ data }) => {
    if (!data || data.from === tabId) return;
    // chegou aba nova e EU estou ativa -> aviso que a vaga está ocupada
    if (data.type === 'hello' && !blocked.value) send({ type: 'taken' });
    // uma aba ativa respondeu ao meu "hello" -> eu (recém-aberta) bloqueio
    if (data.type === 'taken' && awaitingReply) blocked.value = true;
    // outra aba clicou "Usar aqui" -> eu bloqueio
    if (data.type === 'takeover') blocked.value = true;
  };
  awaitingReply = true;
  send({ type: 'hello' });
  // janela curta pra resposta; depois dela, "taken" atrasado não bloqueia
  setTimeout(() => {
    awaitingReply = false;
  }, 1500);
});

const usarAqui = () => {
  blocked.value = false;
  send({ type: 'takeover' });
};

onBeforeUnmount(() => {
  if (channel) channel.close();
});
</script>

<!-- eslint-disable vue/no-bare-strings-in-template -->
<template>
  <div
    v-if="blocked"
    class="flex fixed inset-0 justify-center items-center bg-n-solid-1"
    style="z-index: 99999"
  >
    <div class="p-8 max-w-md text-center">
      <span class="inline-block i-lucide-monitor-x size-12 text-n-slate-11" />
      <h2 class="mt-4 text-lg font-bold text-n-slate-12">
        O sistema já está aberto em outra janela
      </h2>
      <p class="mt-2 text-sm text-n-slate-11">
        Para evitar lentidão, use o sistema em uma única aba. Feche esta
        janela ou clique abaixo para usá-lo aqui.
      </p>
      <button
        type="button"
        class="px-5 py-2.5 mt-6 text-sm font-bold text-white rounded-lg bg-n-brand hover:opacity-90"
        @click="usarAqui"
      >
        Usar aqui
      </button>
    </div>
  </div>
</template>
